import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AsyncUiModule, VaIconModule } from '@vendasta/uikit';
import { MatIconModule } from '@angular/material/icon';
import { FeedbackModule } from '@galaxy/feedback';
import { AccountNameColumnComponent } from './account-name-column/account-name-column.component';
import { AuxDataAccountsTableColumnDirective } from './auxiliary-data-accounts-table-column.directive';
import { CityColumnComponent } from './city-column/city-column.component';
import { PrimaryContactColumnComponent } from './primary-contact-column/primary-contact-column.component';
import { StateColumnComponent } from './state-column/state-column.component';
import { LastUpdateDateColumnComponent } from './last-update-date-column/last-update-date-column.component';

@NgModule({
  declarations: [
    AuxDataAccountsTableColumnDirective,
    AccountNameColumnComponent,
    CityColumnComponent,
    StateColumnComponent,
    LastUpdateDateColumnComponent,
    PrimaryContactColumnComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatProgressSpinnerModule,
    VaIconModule,
    RouterModule,
    FeedbackModule,
    AsyncUiModule,
  ],
})
export class AuxDataAccountsTableColumnsModule {}
